// <auto-submit> — submits the wrapped form whenever a control inside it
// changes. Exists because Phlex (rightly) refuses inline event-handler
// attributes like onchange. Markup convention:
//
//   <auto-submit>
//     <form …>
//       <input type="checkbox" …> <select …> …
//       <noscript><button>Save</button></noscript>
//     </form>
//   </auto-submit>
//
// requestSubmit (not submit()) so validation and the _method override run
// exactly as a button click would. Progressive enhancement: without JS the
// noscript save button does the job.

class AutoSubmit extends HTMLElement {
	#abort: AbortController | null = null;

	connectedCallback() {
		this.#abort?.abort();
		this.#abort = new AbortController();

		this.addEventListener(
			"change",
			(event) => {
				const control = event.target;
				if (
					control instanceof HTMLInputElement ||
					control instanceof HTMLSelectElement ||
					control instanceof HTMLTextAreaElement
				) {
					control.form?.requestSubmit();
				}
			},
			{ signal: this.#abort.signal },
		);
	}

	disconnectedCallback() {
		this.#abort?.abort();
	}
}

if (!customElements.get("auto-submit")) {
	customElements.define("auto-submit", AutoSubmit);
}
